export const formatDate = (date: string | undefined) => {
  if (!date) return '';
  // 2023/10/19 9:32:11の文字列を2023/10/19にする
  return date.split(' ')[0];
};

export const formatDateSlashToJapanese = (dateString: string | undefined) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; //月は0から始まるため+1
  const day = date.getDate();

  return `${year}年${month}月${day}日`;
};
